export default {
  created() {
    if (
      this.$store.state.auth.user.group != "admin" && 
      this.$store.state.auth.user.group != "employee" &&
      this.$store.state.auth.user.group != "financial"
    ) {
      this.allowed = false
      this.$router.push("/not-found")
    }  
  }
}